import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchLoyalty = async ({ page = 1, limit = 10, search = null }) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    if (search) {
      query += `&search=${search}`;
    }
    const response = await authClient.get(`/loyalty/admin/accounts${query}`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju broja korisnika.'
    );
    return { data: null, success: false, message: message };
    // return { data: null, error: message };
  }
};

export const fetchUserHistory = async ({
  page = 1,
  limit = 10,
  userId = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    // if (userId) {
    //   query += `&userId=${userId}`;
    // }
    console.log('Fetching history for userId:', userId);
    const response = await authClient.get(
      `/loyalty/admin/accounts/${userId}/activity${query}`
    );
    console.log('Fetched user history response:', response.data);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju istorije korisnika.'
    );
    return { data: null, success: false, message: message };
    // return { data: null, error: message };
  }
};

export const fetchUserVouchers = async ({
  page = 1,
  limit = 10,
  userId = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    // if (userId) {
    //   query += `&userId=${userId}`;
    // }
    console.log('Fetching history for userId:', userId);
    const response = await authClient.get(
      `/loyalty/admin/accounts/${userId}/vouchers${query}`
    );
    console.log('Fetched user history response:', response.data);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju istorije korisnika.'
    );
    return { data: null, success: false, message: message };
    // return { data: null, error: message };
  }
};

export const adminAwardLoyaltyPoints = async (userId, points) => {
  try {
    const response = await authClient.post(
        `/loyalty/admin/accounts/${userId}/award-points`,
        { points }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri dodavanju poena korisniku.'
    );
    return { data: null, success: false, message };
  }
};

export const adminDeductLoyaltyPoints = async (userId, points, message) => {
  try {
    const response = await authClient.post(
      `/loyalty/admin/accounts/${userId}/deduct-points`,
      { points, ...(message && { message }) }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri oduzimanju poena korisniku.'
    );
    return { data: null, success: false, message };
  }
};
